import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ConfirmationModalOverlayRef } from '@core/customCDK/cdkCustomMdl/classes/confirmation-modal.ref';
import { MdlExitOptions } from '@core/customCDK/cdkCustomMdl/services/common-functions.service';
import { CONFIRMATION_MODAL_DATA } from '@core/customCDK/cdkCustomMdl/tokens/confirmation-data.token';
import { PytCustTblService } from '@core/custome-modal/pytCustTbl/pyt-cust-tbl.service';
import { CopyContentService } from '@core/services/copy.service';
import { ToasterService } from '@core/services/toaster.service';

@Component({
  selector: 'app-credtional-modal',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './credtional-modal.component.html',
  styleUrl: './credtional-modal.component.scss'
})
export class CredtionalModalComponent {
  mapped: any
  constructor(public dialogRef: ConfirmationModalOverlayRef,
    public _PytCustTblService: PytCustTblService,
    private copyService: CopyContentService,
    private toaster: ToasterService,
    @Inject(CONFIRMATION_MODAL_DATA) public data: any,
  ) {

  }
  close($event: MdlExitOptions = MdlExitOptions.BTN_Close) {
    this.dialogRef.events.next({
      type: $event,
    });
  }
  submit() {
    this.close(MdlExitOptions.BTN_Confirm);

  }
  copyText(text: string) {
    this.copyService.copyText(text);
    this.toaster.showSuccess('Copied', 'success');

  }
}
